(function($, window) {

    $(document).ready(function() {

        // Only run this code when there is a slider on the page
        if ($('#sos-donate-slider').length > 0) {

            // determine what triggering
            // help us work out what values should be
            var trigger = 'dealer';

            // when the dragdealer is handled, set it as the trigger
            $('.dragdealer, .dragdealer *').on('mousedown', function() {
                trigger = 'dealer';
            });

                

            // create the donation slider
            var dealer = new Dragdealer('sos-donate-slider', {
                // The default amount should be £12
                x : 0.12,

                animationCallback: function(x, y) {

                    var total = Math.round(x * 100);

                    $('#sos-donate-slider .slider-bar-total').width(total + '%');

                    // if the trigger is dragdealer
                    // then animate the handle and input totals
                    if (trigger === 'dealer') {
                        $('#sos-donate-slider .handle-num').text(total);
                        $('#sos-amount').val(total);
                    }
                },
                callback: function(x, y) {


                    // Make sure that the user cannot select less than 1
                    if (x < 0.01) {
                        x = 0.01;
                        dealer.setValue(x);
                    }

                    // create total for input
                    var total = Math.round(x * 100);

                    // if dragging, set the input amount
                    if(trigger === 'dealer') {
                        $('#sos-amount').val(total);
                    }


                    var value = $('#sos-amount').val();
                    var button =  $('.donate-submit');
                    var error = $('#sos-form-error');

                    window.validate(value, button, error);
                }
            });

            $('#sos-amount').on('blur', function() {

                trigger = 'input';


                // Get the value of the donation input
                var val = $(this).val();
                var x = val / 100;

                if(val > 100) {
                    x = 1;
                }

                dealer.setValue(x);
                $('#sos-donate-slider .handle-num').text(val);

            });

            var val = $('#sos-amount').val();

            // if it is less than 100 ...
            if (val <= 100) {
                // animate the slider to show value
                dealer.setValue(val / 100);
            } else {
                // and set the slider to full width
                dealer.setValue(1, 0);
                // otherwise update the slider number with the value
                $('#sos-donate-slider .handle-num').text(val);
            }

            window.dealer = dealer;

            // End of slider exists check 
        }   
    });

})(jQuery, window);
